module.exports = __webpack_public_path__ + "img/1524695593.54fa1748.jpg";